import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
// A side panel on the native modal dialog: focus stays inside while it is
// open, Escape closes it, and focus goes back to whatever opened it. Render it
// only while open.
export function Drawer({ children, label, onClose }) {
    const ref = useRef(null);
    useEffect(() => {
        const dialog = ref.current;
        if (!dialog)
            return undefined;
        const opener = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        dialog.showModal();
        dialog.querySelector("[autofocus]")?.focus();
        return () => {
            if (dialog.open)
                dialog.close();
            opener?.focus();
        };
    }, []);
    return (_jsx("dialog", { "aria-label": label, className: "m-0 ml-auto h-dvh max-h-dvh w-full max-w-2xl overflow-y-auto bg-surface p-0 text-stone-950 shadow-lg backdrop:bg-stone-950/45 sm:my-5 sm:mr-5 sm:h-auto sm:max-h-[calc(100dvh-2.5rem)] sm:rounded-lg", onCancel: (event) => {
            event.preventDefault();
            onClose();
        }, onClick: (event) => {
            if (event.target === event.currentTarget)
                onClose();
        }, ref: ref, children: children }));
}
